import { ICancelBroadbandEligibility } from "../interfaces/models/ICancelBroadbandEligibility";
import { ECancelBroadbandEligibilityStatus, ICancelBroadbandEligibilityResponse } from "../interfaces/responses";

export const mapCancelBroadbandEligibility = (
    response: ICancelBroadbandEligibilityResponse
): ICancelBroadbandEligibility => ({
    displayCancelButton: response.status === ECancelBroadbandEligibilityStatus.IS_ELIGIBLE,
});
